<template>
    <div class="relative">
        <select 
            v-model="selectedStatus"
            class="bg-white border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 focus:ring-2 focus:outline-none block w-full p-2.5"
            @change="emitStatus"
        >
            <option value="Pending">Pendientes</option>
            <option value="Finished">Finalizadas</option>
        </select>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, defineEmits } from 'vue';

const emit = defineEmits(['update:status']);
const selectedStatus = ref('Pending');

// Cargar el estado guardado al montar el componente
onMounted(() => {
    const savedStatus = localStorage.getItem('selectedStatus');
    if (savedStatus) {
        selectedStatus.value = savedStatus;
        emit('update:status', savedStatus);
    }
});

const emitStatus = () => {
    // Guardar el nuevo estado en localStorage
    localStorage.setItem('selectedStatus', selectedStatus.value);
    emit('update:status', selectedStatus.value);
};
</script>